define.alias("ember-math-helpers/helpers/cosh", "calendar/helpers/cosh");